import { StrictModal } from '@c/Ui'
import { useCallback, useEffect, useState } from 'react'

import {
  redirectToWordPressAuthPage,
  startCleverMapSubscriptionFromWebapp,
} from '@/api/cleverMapSubscription.api'
import { useAppDispatch, useAppSelector } from '@/core/store'
import { closeModal } from '@/core/store/ui.store'

function getCookie(name: string): string | null {
  const cookies = document.cookie.split('; ')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null
}

export function CleverMapAccessModal() {
  const dispatch = useAppDispatch()
  const [buyLoading, setBuyLoading] = useState(false)
  const { hasCleverMapAccess } = useAppSelector((store) => store.catalogStore)

  useEffect(() => {
    if (hasCleverMapAccess === true) dispatch(closeModal())
  }, [hasCleverMapAccess, dispatch])

  const onBuyNow = useCallback(async () => {
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    const accountUrl = `${process.env.REACT_APP_WP_URL}/my-account/`
    if (!refresh_token || !user_id) {
      if (!window.open(accountUrl, '_blank', 'noopener,noreferrer')) {
        window.location.href = accountUrl
      } else {
        dispatch(closeModal())
      }
      return
    }
    setBuyLoading(true)
    dispatch(closeModal())
    await startCleverMapSubscriptionFromWebapp(refresh_token, user_id)
    setBuyLoading(false)
  }, [dispatch])

  const onSelectTour = useCallback(() => {
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    if (!refresh_token || !user_id) {
      redirectToWordPressAuthPage()
      return
    }
    dispatch(closeModal())
    window.dispatchEvent(new Event('open-tours-tab'))
  }, [dispatch])

  return (
    <StrictModal name="clever_map_access" closeOnBackdropClick>
      <div className="clever-map-access">
        <p className="clever-map-access__intro">To continue:</p>
        <h2 className="clever-map-access__title">Buy full access</h2>
        <p className="clever-map-access__product">Clever Map - for 1 year for € 7</p>
        <button
          type="button"
          className="clever-map-access__btn clever-map-access__btn--primary"
          disabled={buyLoading}
          onClick={onBuyNow}
        >
          Buy now
        </button>
        <p className="clever-map-access__hint">Or buy any tour and get free access to Clever Map</p>
        <button
          type="button"
          className="clever-map-access__btn clever-map-access__btn--ghost"
          onClick={onSelectTour}
        >
          Select tour
        </button>
      </div>
    </StrictModal>
  )
}
